import { useEffect } from "react";
import { useGetCarcinogenicReportQuery } from "../../../services/carcinogenicApi";
import { useDispatch } from "react-redux";
import { setCarcinogenicReportData } from "../../../redux/slices/carcinogenicReportSlice";

const useCarcinogenicReportPrecharge = (carcinogenicReportId: number | null) => {
    const dispatch = useDispatch();
    const {
        data: carcinogeniReportInitialData,
        isSuccess,
        isFetching: isFetchingCarcinogenicReportInitialData
    } = useGetCarcinogenicReportQuery(carcinogenicReportId, { skip: !carcinogenicReportId });

    useEffect(() => {
        if(isSuccess && carcinogeniReportInitialData?.data) {
            dispatch(setCarcinogenicReportData(carcinogeniReportInitialData?.data));
        }
    }, [carcinogeniReportInitialData]);
    return { carcinogeniReportInitialData, isFetchingCarcinogenicReportInitialData };
};

export default useCarcinogenicReportPrecharge;
